import { useCallback, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router'

interface ExpertProfitAndLossSearchParam {
  search: string
  setSearch: (value: string) => void
}

export const useExpertProfitAndLossSearchParam = (): ExpertProfitAndLossSearchParam => {
  const navigate = useNavigate()
  const { pathname, search: locationSearch } = useLocation()

  const search = useMemo(() => (new URLSearchParams(locationSearch).get('search') ?? '').trim(), [locationSearch])

  const setSearch = useCallback(
    (value: string) => {
      const searchParams = new URLSearchParams(locationSearch)
      const trimmedSearch = value.trim()

      if (trimmedSearch) {
        searchParams.set('search', trimmedSearch)
      } else {
        searchParams.delete('search')
      }

      const nextSearch = searchParams.toString()

      navigate(nextSearch ? `${pathname}?${nextSearch}` : pathname, { replace: true })
    },
    [navigate, locationSearch, pathname],
  )

  return { search, setSearch }
}
